import { Variant } from '@/lib/interfaces';
import { reactQueryKeys } from '@/utils/reactQueryKeys';
import { getSingleVariantById } from '@/utils/v2HttpRequests';
import { useQuery } from 'react-query';

export default function useGetVariantById(
  id: string | number,
  query: string = '',
  enabled: boolean = true
) {
  return useQuery<Variant, Error>(
    [reactQueryKeys.GET_VARIANT_BY_ID, id, query],
    () => getSingleVariantById(id, query),
    {
      enabled,
      refetchOnWindowFocus: false,
    }
  );
}
